(function () {
  /**
   * Replaces the theme's <shopify-account> web component state with real
   * ErosSession state. header.liquid / header-sidebar.liquid render a plain
   * signed-out-by-default link (data-eros-account-link) to avoid a flash of
   * wrong state before this script runs; this only ever needs to swap
   * href/text/class, not build new markup.
   */

  var STR = (window.ErosAccountStrings && window.ErosAccountStrings.header) || {};
  function t(key, fallback) {
    return STR[key] || fallback;
  }

  function applyState(session) {
    var links = document.querySelectorAll('[data-eros-account-link]');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      // /pages/account, not /account — this shop's Shopify "new Customer
      // Accounts" intercepts /account/* before theme Liquid renders
      // (see docs/decisions/ADR-174-web-native-commerce-account-checkout.md).
      link.href = '/pages/account';
      if (session && session.customerGid) {
        link.classList.add('eros-account-link--signed-in');
        link.setAttribute('aria-label', t('account_signed_in', 'حسابي'));
      } else {
        link.classList.remove('eros-account-link--signed-in');
        link.setAttribute('aria-label', t('account_signed_out', 'تسجيل الدخول'));
      }
    }
  }

  window.ErosSession.onChange(applyState);
})();
